import * as Sentry from "@sentry/react";
import { create } from "zustand";
import api from "../api/client";

function _setSentryUser(user) {
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email });
  } else {
    Sentry.setUser(null);
  }
}

const useAuthStore = create((set) => ({
  // State
  user: null,
  loading: true,
  error: null,

  // Actions
  checkAuth: async () => {
    try {
      const user = await api.get("/auth/me");
      _setSentryUser(user);
      set({ user, loading: false, error: null });
      return true;
    } catch {
      _setSentryUser(null);
      set({ user: null, loading: false, error: null });
      return false;
    }
  },

  login: async (email, password) => {
    set({ error: null });
    try {
      const user = await api.post("/auth/login", { email, password });
      _setSentryUser(user);
      set({ user, loading: false, error: null });
      return true;
    } catch (err) {
      set({ error: err.detail?.detail || err.message || "Erreur de connexion" });
      return false;
    }
  },

  updateUser: (updatedUser) => set({ user: updatedUser }),

  logout: async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // Clear state even if the request fails
    }
    _setSentryUser(null);
    set({ user: null, loading: false, error: null });
  },
}));

export default useAuthStore;
